import React, { useEffect } from 'react';

import { MenuItem } from '@mui/material';

import TextFieldControlled from 'components/shared/TextFieldControlled';

import { useFormContext } from 'react-hook-form';

import { useRefundReasonsSWR } from '../../../hooks';

import type RefundForm from '../../../models/RefundForm';

const SelectRefundReason: React.FC = () => {
    const form = useFormContext<RefundForm>();

    const { refundReasons, loading } = useRefundReasonsSWR();

    const reasonId = form.watch('reason.id');

    useEffect((): void => {
        const reason = refundReasons?.find((item) => item.id === reasonId);
        if (!reason) return;
        form.setValue('reason.is_other_reason', reason.is_other_reason);
    }, [reasonId, refundReasons]);

    if (loading || !refundReasons) return null;

    return (
        <TextFieldControlled control={form.control} name="reason.id" select>
            {refundReasons.map((reason, index) => (
                <MenuItem key={index} value={reason.id}>
                    {reason.label}
                </MenuItem>
            ))}
        </TextFieldControlled>
    );
};

export default SelectRefundReason;
